// executiveDashboard module getters.js
export default {
  brands: state => state.brands,
  loading: state => state.loading,
  error: state => state.error,
  executiveSummaries: state => {
    return state.executiveSummaries;
  },
  products: state => state.products
}
